module.exports = __webpack_public_path__ + "static/media/hot.a9ec4f5a.jpg";